<template>
  <div
    @click="closeModal($event.target, false)"
    class="modal fade"
    :class="[authenticationStore.modal ? 'show' : 'hide']"
    id="accountSettingsModal"
    tabindex="-1"
    aria-labelledby="accountSettingsModalLabel"
    aria-hidden="true"
    :style="{ display: [authenticationStore.modal ? 'block' : 'none'] }"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content" ref="AccountSettingsModalContent">
        <div class="modal-header">
          <h5 class="modal-title" id="accountSettingsModalLabel" v-t="'message.AccountSettings.title'"></h5>
          <button
            type="button"
            class="btn-close"
            @click="closeModal($event.target, true)"
            aria-label="Close"
          ></button>
        </div>
        <form>
          <div class="modal-body">
            <div class="row">
              <div class="mb-5 col-12 col-sm-6">
                <label for="profile-firstname" class="h6 text-muted ps-1 form-label text-capitalize" v-t="'message.AccountSettings.first_name'"></label>
                <input
                  type="text"
                  class="form-control"
                  id="profile-firstname"
                  v-model="authenticationStore.me.firstname"
                  :placeholder="authenticationStore.me.firstname"
                  :disabled="schoolStore.isIntegrated() && !schoolStore.allowRegistration()"
                />
              </div>
              <div class="mb-5 col-12 col-sm-6">
                <label for="profile-lastname" class="h6 text-muted ps-1 form-label text-capitalize" v-t="'message.AccountSettings.last_name'"></label>
                <input
                  type="text"
                  class="form-control"
                  id="profile-lastname"
                  v-model="authenticationStore.me.lastname"
                  :placeholder="authenticationStore.me.lastname"
                  :disabled="schoolStore.isIntegrated() && !schoolStore.allowRegistration()"
                />
              </div>
              <div class="mb-5 col-12 col-sm-6">
                <label for="profile-email" class="h6 text-muted ps-1 form-label text-capitalize" v-t="'message.AccountSettings.email'"></label>
                <input
                  type="text"
                  class="form-control"
                  id="profile-email"
                  v-model="authenticationStore.me.email"
                  :placeholder="authenticationStore.me.email"
                  :disabled="schoolStore.isIntegrated() && !schoolStore.allowRegistration()"
                />
              </div>
              <div class="mb-5 col-12 col-sm-6">
                <label for="profile-phone" class="h6 text-muted ps-1 form-label text-capitalize" v-t="'message.AccountSettings.phone'"></label>
                <input
                  type="text"
                  class="form-control"
                  id="profile-phone"
                  :placeholder="authenticationStore.me.phone"
                  v-model="authenticationStore.me.phone"
                />
              </div>
              <div class="mb-5 col-12 col-sm-6">
                <label for="profile-username" class="h6 text-muted ps-1 form-label text-capitalize" v-t="'message.AccountSettings.username'"></label>
                <input
                  type="text"
                  class="form-control"
                  id="profile-username"
                  v-model="authenticationStore.me.external_login_id"
                  autocomplete="username"
                  :placeholder="authenticationStore.me.external_login_id"
                  :disabled="schoolStore.isIntegrated()"
                />
              </div>
              <div class="mb-5 col-12 col-sm-6">
                <label for="profile-password" class="h6 text-muted ps-1 form-label text-capitalize" v-t="'message.AccountSettings.password'"></label>
                <input
                  type="password"
                  class="form-control"
                  id="profile-password"
                  placeholder="Password"
                  autocomplete="current-password"
                  v-model="password"
                  :disabled="
                    schoolStore.isIntegrated() && schoolStore.isPasswordUpdatable() == false
                  "
                />
              </div>
            </div>
            
            <!-- Tabs for Students and Teachers -->
            <v-tabs 
              v-model="activeTab" 
              class="custom-tabs"
              color="primary"
              slider-color="primary"
            >
              <v-tab value="students" v-t="'message.AccountSettings.students'"></v-tab>
              <v-tab value="teachers" v-t="'message.AccountSettings.teachers'" v-if="listTeachers().length > 0 && schoolStore.isIntegrated() == true"></v-tab>
            </v-tabs>
            
            <v-tabs-window v-model="activeTab">
              <!-- Students Tab -->
              <v-tabs-window-item value="students">
                <div class="vstack gap-0">
              <div
                class="row row-student"
                :data-editable="student.modified != null && student.modified == true"
                v-for="student in listStudents()"
                :key="student.uid"
              >
                <div class="col">
                  <div class="row g-1">
                    <div class="col-6">
                      <input
                        type="text"
                        aria-label="First name"
                        class="form-control"
                        v-model="student.child_fname"
                        :disabled="student.loading"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        type="text"
                        aria-label="Last name"
                        class="form-control"
                        v-model="student.child_lname"
                        :disabled="student.loading"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-5 col-sm-4 col-lg-3">
                  <div
                    class="btn-group w-100"
                    role="group"
                    v-if="
                      (student.modified == null || student.modified == false) &&
                      (schoolStore.isIntegrated() == false || schoolStore.allowRegistration())
                    "
                  >
                    <button class="btn btn-outline-secondary px-0" type="button" @click="student.modified = true" v-t="'message.AccountSettings.edit'" v-if="!schoolStore.isIntegrated()"></button>
                    <button class="btn btn-outline-danger px-0" type="button" @click="student.deleteme = true" v-t="'message.AccountSettings.remove'" v-if="!student.deleteme"></button>
                  </div>
                  <div
                    class="btn-group w-100"
                    role="group"
                    v-else-if="schoolStore.isIntegrated() == false"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary px-0"
                      :class="{ 'loading-spinner': student.loading }"
                      @click="saveStudent(student)"
                      :disabled="student.loading"
                      v-t="'message.AccountSettings.save'"
                    >
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-danger px-0"
                      @click="student.modified = false"
                      :disabled="student.loading"
                      v-t="'message.AccountSettings.cancel'"
                    >
                    </button>
                  </div>
                  <div
                    class="confirm-cancel"
                    v-if="student.deleteme != null && student.deleteme == true"
                  >
                    <span v-t="'message.AccountSettings.remove_message'"></span>
                    <button
                      class="btn btn-primary"
                      :class="{ 'loading-spinner': student.loading }"
                      :disabled="student.loading"
                      @click="removeStudent(student)"
                      v-t="'message.AccountSettings.yes'"
                    ></button>
                    <button
                      class="btn btn-outline-primary"
                      :disabled="student.loading"
                      @click="[(student.deleted = false), (student.deleteme = false)]"
                      v-t="'message.AccountSettings.no'"
                    ></button>
                  </div>
                </div>
              </div>
              <div
                class="row row-student"
                :data-editable="schoolStore.allowRegistration()"
                v-if="schoolStore.allowRegistration()"
              >
                <div class="col">
                    <div class="row g-1">
                      <div class="col-6">
                        <input
                          type="text"
                          placeholder="Student ID"
                          aria-label="Student ID"
                          class="form-control"
                          v-model="newstudent.external_id"
                        />
                      </div>
                      <div class="col-5 col-sm-4 col-lg-3">
                        <div class="btn-group w-100" role="group">
                          <button class="btn btn-outline-primary px-0" 
                          :class="{ 'loading-spinner': newstudent.loading }"
                          :disabled="newstudent.loading"

                          type="button" @click="getStudent(newstudent.external_id)" v-t="'message.AccountSettings.add_student'"></button>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              
              <div
                class="row row-student"
                :data-editable="!schoolStore.isIntegrated()"
                v-if="schoolStore.isIntegrated() == false"
              >
                <div class="col">
                  <div class="row g-1">
                    <div class="col-6">
                      <input
                        type="text"
                        placeholder="First Name"
                        aria-label="First name"
                        required
                        pattern=".*\S+.*"
                        class="form-control"
                        v-model="newstudent.child_fname"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        type="text"
                        placeholder="Last Name"
                        aria-label="Last name"
                        required
                        pattern=".*\S+.*"
                        class="form-control"
                        v-model="newstudent.child_lname"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-5 col-sm-4 col-lg-3">
                  <div class="btn-group w-100" role="group" v-if="isNotEmpty(newstudent)">
                    <button class="btn btn-outline-primary px-0" type="button" @click="addStudent" v-t="'message.AccountSettings.add_student'"></button>
                  </div>
                </div>
              </div>

                  <div
                    class="alert alert-danger"
                    role="alert"
                    v-if="
                      !authenticationStore.me.students || authenticationStore.me.students.length == 0
                    "
                  >
                    <i class="bi bi-exclamation-triangle-fill me-2"></i> 
                    <span v-t="'message.AccountSettings.student_alert_message'"></span>
                  </div>
                </div>
              </v-tabs-window-item>
              
              <!-- Teachers Tab -->
              <v-tabs-window-item value="teachers">
                <div class="vstack gap-0">
                  <div
                    class="row row-student"
                    v-for="teacher in listTeachers()"
                    :key="teacher.uid"
                  >
                    <div class="col">
                      <div class="row g-1">
                        <div class="col-6">
                          {{ teacher.teacher_fname }}
                          
                        </div>
                        <div class="col-6">
                          {{ teacher.teacher_lname }}
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div
                    class="alert alert-info"
                    role="alert"
                    v-if="!listTeachers() || listTeachers().length == 0"
                  >
                    <i class="bi bi-info-circle-fill me-2"></i> 
                    <span>No teachers found</span>
                  </div>
                </div>
              </v-tabs-window-item>
            </v-tabs-window>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary me-auto"
              data-bs-dismiss="modal"
              v-if="authenticationStore.me.students && authenticationStore.me.students.length > 0"
              @click="logout($event.target, true)"
              v-t="'message.AccountSettings.logout'"
            ></button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              v-if="authenticationStore.me.students && authenticationStore.me.students.length > 0"
              @click="closeModal($event.target, true)"
              v-t="'message.AccountSettings.close'"
            ></button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ 'loading-spinner': authenticationStore.loading }"
              @click="save"
              v-if="schoolStore.isIntegrated() == false || schoolStore.isPasswordUpdatable()"
              v-t="'message.AccountSettings.save'"
            ></button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-if="authenticationStore.modal"></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { FetchService } from "@/services/fetch.service";
import { useSchoolStore } from "@/stores/school";
import { useAlertsStore } from "@/stores/alerts";
import { useConferenceStore} from "@/stores/parent/conference";

const AccountSettingsModalContent = ref(null);
const schoolStore = useSchoolStore();
const alertStore = useAlertsStore();
const authenticationStore = useAuthenticationStore();
const conferenceStore = useConferenceStore();

const newstudent = ref({});
const password = ref(null);
const loading = ref(false);
const showLogout = ref(false);
const activeTab = ref('students');

function logout(){
    authenticationStore.logout();
    document.location.reload();
}
  
function closeModal(el, override) {
  
  if (schoolStore.school_id == 2065 && (!authenticationStore.me.phone || authenticationStore.me.phone == '') ){
    showLogout.value=true;    
    return false;
  }
  if (listStudents().length == 0) {
    showLogout.value=true;    
    return false;
  } else if (override || el.contains(AccountSettingsModalContent.value)) {
    authenticationStore.modal = false;
    try {
      conferenceStore.fetchConferences().then(() => {
        console.log("Conference Data Loaded");
      });
    } catch (e) {
      console.log(e);
    }
  }
}

function listStudents() {
  if (authenticationStore.me?.students !== undefined) {
    return authenticationStore.me.students.filter((student) => {
      return !student.deleted || student.deleted === false || student.deleted === 'no';
    });
  } else if (authenticationStore.me.students == null) {
    return [];
  } else {
    return null;
  }
}
function listTeachers() {
  if (authenticationStore.me?.teachers && authenticationStore.me.teachers.length > 0) {
    return authenticationStore.me.teachers.filter((teacher) => {
      return !teacher.deleted || teacher.deleted === false || teacher.deleted === 'no';
    });
  } else {
    return [];
  }
}
function isNotEmpty(student){
  return (
    typeof student === 'object' &&
    typeof student.child_fname === 'string' &&
    student.child_fname.trim() !== '' &&
    typeof student.child_lname === 'string' &&
    student.child_lname.trim() !== ''
  );
}
function addStudent() {
  if( newstudent.child_fname == ' '){
    console.log("Space is not a valid child first name");
    newstudent.value = {};
    return false;
  }
  authenticationStore.me.students.push(newstudent.value);
  saveStudent(newstudent.value);
  newstudent.value = {};
}

async function getStudent(external_id) {
  newstudent.value.loading = true;
  
  console.log("getting student for "+external_id);
  if (external_id){
    
    const students = await FetchService.fetchData("/students/"+external_id, "get");
    if (!students || students.length == 0){
      newstudent.value.loading = false;
      console.log("No students found");
      alertStore.addAlert('error','Student ID does not exist',5);
      return false;
    }
    // authenticationStore.me.students = authenticationStore.me.students.concat(student);
    // await authenticationStore.fetchProfile();
    // if (student && student?.uid){
    //   console.log(student);
    //   saveStudent(student);
    // }
    await authenticationStore.fetchProfile();
    newstudent.value.external_id='';
    newstudent.value.loading = false;
    // student.loading = false;
    
  }
}

async function saveStudent(student) {
  if (student.child_fname == ' '){
    console.log("Space is not valid for student name");
    return false;
  }
  student.loading = true;
  if (student.uid != undefined) {
    // FetchService.fetchData("/students/"+student.uid,"put",student).then(response=>{authenticationStore.fetchProfile(); student.loading=false;});
    await FetchService.fetchData("/students/" + student.uid, "put", student);
    await authenticationStore.fetchProfile();
    student.loading = false;
  } else if (student.deleted == undefined || student.deleted == null || !student.deleted) {
    student.parent_uid = authenticationStore.me.uid;
    student.external_id = student.child_fname + student.child_lname;
    // FetchService.fetchData("/students","post",student).then(response=>{authenticationStore.fetchProfile(); student.loading=false;});
    await FetchService.fetchData("/students", "post", student);
    await authenticationStore.fetchProfile();
    student.loading = false;
  }
}

async function removeStudent(student) {
  student.deleted = true;
  // saveStudent(student);
  // FetchService.fetchData("/students/"+student.uid,"delete",student).then(response=>{authenticationStore.fetchProfile(); student.loading=false;});
  await FetchService.fetchData("/students/" + student.uid, "delete", student);
  await authenticationStore.fetchProfile();
  student.loading = false;
}

async function save() {
  authenticationStore.loading = true;
  var guardian = {
    firstname: authenticationStore.me.firstname,
    lastname: authenticationStore.me.lastname,
    email: authenticationStore.me.email,
    external_login_id: authenticationStore.me.external_login_id,
    phone: authenticationStore.me.phone,
    consent: authenticationStore.me.email_consent
  };
  if (password.value != null) {
    guardian["password"] = password.value;
  }

  // FetchService.fetchData("/guardians/"+authenticationStore.me.uid,"put",guardian).then(response=>{authenticationStore.fetchProfile(); authenticationStore.loading=false;});
  await FetchService.fetchData("/guardians/" + authenticationStore.me.uid, "put", guardian);
  await authenticationStore.fetchProfile();
  authenticationStore.loading = false;
  if (listStudents().length > 0) {
    authenticationStore.modal=false;
  }
  try {
      conferenceStore.fetchConferences().then(() => {
        console.log("Conference Data Loaded");
      });
    } catch (e) {
      console.log(e);
    }
}

onMounted(() => {
  if (authenticationStore.me.students == undefined) {
    console.log("me loading...");
  } else {
    if (schoolStore.school_id == 2065 && (!authenticationStore.me.phone || authenticationStore.me.phone == '') ){
      authenticationStore.modal = true;
    }
    if (listStudents() != null && listStudents().length == 0) {
      console.log("need to show account settings");
      authenticationStore.modal = true;
    }
  }
});
</script>

<style scoped>
.custom-tabs :deep(.v-tab) {
  border: 1px solid #dee2e6;
  border-bottom: none;
  border-radius: 0.375rem 0.375rem 0 0;
  background-color: #f8f9fa;
  margin-right: 2px;
}

.custom-tabs :deep(.v-tab--selected) {
  background-color: #fff;
  border-bottom: 1px solid #fff;
  font-weight: 500;
}

.custom-tabs :deep(.v-tab:hover) {
  background-color: #e9ecef;
}

.custom-tabs :deep(.v-tab--selected:hover) {
  background-color: #fff;
}

.custom-tabs :deep(.v-tabs) {
  border-bottom: 1px solid #dee2e6;
}
</style>
